import { IconNG } from '../../Icon'
import {
  getFileIcon,
  getFileIconColor,
  getFileIconType,
} from '../FileIcon.utils'

import * as styles from './FileIcon.module.css'

function FileIcon({
  className = styles.FileIcon,
  file,
  getIcon = getFileIcon,
  getIconColor = getFileIconColor,
  getIconType = getFileIconType,
  type,
  ...restProps
}) {
  const fileType = type || getIconType(file)
  const Icon = getIcon(fileType)
  const iconColor = getIconColor(fileType)

  return (
    <IconNG
      {...restProps}
      Icon={Icon}
      className={className}
      color={iconColor}
    />
  )
}

export default FileIcon
